module.exports = __webpack_public_path__ + "dcd4de8ed80bfb012d30ea4887db761a.svg";